import axios from "axios";
import endpoints from "../../config/endpoints.config";

const getCompany = async (companyName, token) => {
	// if (!token) {
	//     console.log('No token')
	//     return
	// }

	const url = `${endpoints.b2b.singleCompany}?companyName=${companyName}`;
	const { data } = await axios.get(url, {
		headers: {
			Authorization: token,
		},
	});
	//console.log("getCompany", data);

	return data;
};

export default getCompany;
